import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'

Validator.extend('has-upper', {
    getMessage (field) {
        return 'The ' + field + ' field must have at least one uppercase letter'
    },
    validate (value) {
        let regexp = new RegExp('^(?=.*[A-Z])')
        return regexp.test(value)
    }
})
Validator.extend('has-lower', {
    getMessage (field) {
        return 'The ' + field + ' field must have at least one lowercase letter'
    },
    validate (value) {
        let regexp = new RegExp('^(?=.*[a-z])')
        return regexp.test(value)
    }
})
Validator.extend('has-number', {
    getMessage (field) {
        return 'The ' + field + ' field must have at least one numeric value'
    },
    validate (value) {
        let regexp = new RegExp('^(?=.*[0-9])')
        return regexp.test(value)
    }
})
Validator.extend('has-symbol', {
    getMessage (field) {
        return 'The ' + field + ' field must have at least one special symbol (^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ `)'
    },
    validate (value) {
        let symbols = [
            '^', '$', '*', '.', '[', ']', '{', '}', '(', ')', '?', '-', '"', '!', '@',
            '#', '%', '&', '/', '\\', ',', '>', '<', '\'', ':', ';', '|', '_', '~', '`'
        ]
        for (let symbol of symbols) if (value.indexOf(symbol) !== -1) return true
        return false
    }
})

Validator.extend('decimal_custom', {
    getMessage (field) {
        return 'The ' + field + ' field must be numeric and have at least one digit'
    },
    validate (value) {
        let regexp = new RegExp(/^(\d+)?([.]?\d{0,1})?$/)
        return regexp.test(value)
    }
})

Vue.use(VeeValidate)

export default VeeValidate
